import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import { jsx, jsxs } from 'react/jsx-runtime';
import { Modal } from '@dls/web';
import styled from 'styled-components';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ScrollableModal = props => {
  return /* @__PURE__ */jsx(Modal, __spreadProps(__spreadValues({
    alignCenter: true
  }, props), {
    children: props.children
  }));
};
ScrollableModal.Content = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */jsx(ModalContentWrapper, {
    children: /* @__PURE__ */jsx(Modal.Content, {
      children
    })
  });
};
ScrollableModal.Footer = _ref2 => {
  let {
    children
  } = _ref2;
  return /* @__PURE__ */jsxs(ModalFooter, {
    children: [/* @__PURE__ */jsx("div", {
      className: "placeholder"
    }), /* @__PURE__ */jsx("div", {
      className: "footer",
      children
    })]
  });
};
const ModalContentWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n"])));
const ModalFooter = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  .footer {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    box-sizing: border-box;\n    height: 90px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #ffffff;\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n  }\n\n  .placeholder {\n    height: 90px;\n  }\n"])));
export { ScrollableModal as default };